function mmInitProductOptionsModals() {
	const blocks = document.querySelectorAll('.mm-product-options[data-instance-id]');
	if (!blocks.length) {
		return;
	}

	blocks.forEach((block) => {
		const modal = block.querySelector('[data-option-modal="true"]');
		const form = block.querySelector('[data-option-contact-form="true"]');
		if (!modal || !form) {
			return;
		}

		const selectedTitleEl = block.querySelector('[data-selected-option-title]');
		const selectedTitleInput = block.querySelector('[data-selected-option-title-input]');
		const selectedIdInput = block.querySelector('[data-selected-option-id]');
		const feedbackEl = block.querySelector('[data-form-feedback="true"]');
		const thanksEl = block.querySelector('[data-form-thanks="true"]');
		const submitBtn = form.querySelector('button[type="submit"]');

		const closeModal = () => {
			modal.hidden = true;
			document.body.classList.remove('mm-product-options-modal-open');
		};

		const openModal = (optionTitle, optionId) => {
			if (selectedTitleEl) {
				selectedTitleEl.textContent = optionTitle || '';
			}
			if (selectedTitleInput) {
				selectedTitleInput.value = optionTitle || '';
			}
			if (selectedIdInput) {
				selectedIdInput.value = optionId || '';
			}
			if (feedbackEl) {
				feedbackEl.textContent = '';
			}
			if (thanksEl) {
				thanksEl.hidden = true;
			}
			form.hidden = false;
			modal.hidden = false;
			document.body.classList.add('mm-product-options-modal-open');
		};

		block.querySelectorAll('[data-open-option-modal="true"]').forEach((btn) => {
			btn.addEventListener('click', () => {
				openModal(btn.getAttribute('data-option-title'), btn.getAttribute('data-option-id'));
			});
		});

		modal.querySelectorAll('[data-option-modal-close="true"]').forEach((btn) => {
			btn.addEventListener('click', closeModal);
		});

		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape' && !modal.hidden) {
				closeModal();
			}
		});

		form.addEventListener('submit', (e) => {
			e.preventDefault();
			if (feedbackEl) {
				feedbackEl.textContent = '';
			}
			if (submitBtn) {
				submitBtn.disabled = true;
			}

			const ajaxUrl = block.getAttribute('data-ajax-url');
			const formData = new FormData(form);

			fetch(ajaxUrl, {
				method: 'POST',
				credentials: 'same-origin',
				body: formData,
			})
				.then((res) => res.json())
				.then((data) => {
					if (!data || data.success !== true) {
						const msg = data && data.data && data.data.message ? data.data.message : 'Versturen is niet gelukt.';
						if (feedbackEl) {
							feedbackEl.textContent = msg;
						}
						return;
					}

					form.reset();
					form.hidden = true;
					if (thanksEl) {
						thanksEl.hidden = false;
					}
				})
				.catch(() => {
					if (feedbackEl) {
						feedbackEl.textContent = 'Versturen is niet gelukt.';
					}
				})
				.finally(() => {
					if (submitBtn) {
						submitBtn.disabled = false;
					}
				});
		});
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', mmInitProductOptionsModals);
} else {
	mmInitProductOptionsModals();
}
